export default function Node_Home() {
  return <div>Node_Home Component</div>;
}
